<template>
  <div>
    <base-section
      id="enduserparameters-account"
      space="16"
    >
      <v-container>
        <kdw-Statusbar-card
          v-model="snackbarUpdate"
          :snackbar-timeout="snackbarTimeout"
          :snackbar-message="snackbarMessage"
        />
        <!-- <v-snackbar
          v-model="snackbarUpdate"
          :timeout="snackbarTimeout"
          color="blue-grey"
          rounded="pill"
          top
        >
          {{ snackbarMessage }}
          <template v-slot:action="{ attrs }">
            <v-btn
              text
              v-bind="attrs"
              @click="snackbarUpdate = false"
            >
              {{ $t('button.close') }}
            </v-btn>
          </template>
        </v-snackbar>
        -->
        <v-row justify="space-between">
          <v-col
            cols="12"
            md="12"
          >
            <base-info-card :title="$t('paramEU.mainTitle')" />
          </v-col>
        </v-row>
        <v-row>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>
                mdi-web
              </v-icon>
              {{ $t('paramEU.language') }}
            </v-tab>
            <!--- Language option  ------------------------------------------------->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <p>{{ $t('paramEU.language_line1') }}</p>
                  <v-radio-group
                    v-model="parameters.language.default"
                  >
                    <v-radio
                      key="1"
                      :label="$t('paramEU.english')"
                      value="en"
                    />

                    <v-radio
                      key="2"
                      :label="$t('paramEU.french')"
                      value="fr"
                    />
                  </v-radio-group>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <kdw-btn
                    @click="updateParameters"
                  >
                    {{ $t('button.validateQuestion') }}
                  </kdw-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-row>
      </v-container>
    </base-section>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator'
  import { loadEndUserParameters, saveEndUserParameters } from '@/services/Parameters'
  import { Logger } from 'aws-amplify'

  const logger = new Logger('EnduserParametersAccount')

  @Component({ name: 'EndUserParametersAccount' })
  class EndUserParametersAccount extends Vue {
    snackbarUpdate = false
    snackbarMessage = ''
    snackbarTimeout = 2000
    parameters = { language: { default: 'fr' } }

    alertSnackBar (message, snackbarTimeout) {
      this.snackbarMessage = message
      this.snackbarUpdate = true
      this.snackbarTimeout = snackbarTimeout
    }

    created () {
      loadEndUserParameters()
        .then(result => {
          if (result !== false) {
            // console.log(result)
            if (result.parameters !== undefined) {
              const parametersLoaded = JSON.parse(result.parameters)
              this.parameters.language.default = parametersLoaded.language.default
              // console.log(this.parameters)
            }
          }
        })
        .catch(err => logger.error(err))
    }

    updateParameters () {
      saveEndUserParameters(this.parameters)
        .then((result) => {
          if (result === true) {
            this.alertSnackBar(this.$i18n.t('paramEU.alertUpdateOK'), 2000)
          } else {
            this.alertSnackBar(this.$i18n.t('parameterLib.alertFailSave'), -1)
          }
        })
        .catch(err => {
          logger.error(err)
          this.alertSnackBar(this.$i18n.t('parameterLib.alertFailSave'), -1)
        })
    }
  }

  export default EndUserParametersAccount
</script>
